import React from 'react'
import Header from './components/Header/Header'
import Home from './components/Home/Home'
import './styles.css'

export default function App() {
  return (
    <>
      <Header />
      <Home />
    </>
  )
}
